import React, { Component } from 'react';
import './Item.css'
import {connect} from 'react-redux'
import WorkDocCheckCarDoc from '../../workdoc/WorkDocCheckCarDoc'
class Item extends Component {

  constructor(props) {
    super(props)

    this.state = {}
  }

  componentDidMount() {
    
  }

  render() {
    let {messages} = this.props
    return(
  		<div>
  			<h3>{messages['Car Type Config']}</h3>
        <WorkDocCheckCarDoc
          // workNo='SRY.0329/2562'
          mode='account-settings'
        />
  		</div>
  	)
  }

}
 
export default Item = connect(
  (state) => ({messages: state.message.view.settings.Menu10.Item}),null,null,{withRef:true}
)(Item);



// WEBPACK FOOTER //
// ./src/view/settings/Menu10/Item.js